<div id="courses">
    <div class="container">
        <div class="row">
            <div class="col-12" data-scroll>
                <h2 class="home-title text-center">
                    Programmes Made For You
                </h2>
            </div>
        </div>
        <div class="row row-cols-1 row-cols-md-2 row-cols-lg-4 mt-4 g-4 justify-content-center">
            <!-- BBA -->
            <div class="col d-flex" data-scroll>
                <div class="card mx-auto w-100">
                    <img src="/assets/img/course/BBA.png" alt="BBA" class="card-img img-fluid" />
                    <span class="first">BBA</span>
                    <div class="card-body">
                        <h6 class="line-clamp-5">
                            The Management Programme (BBA) provides an unparalleled opportunity for students to
                            gain insights into the key processes that define management. The programme offers a
                            combination of theory and practice, including advanced business-related problem-solving,
                            seminars and discussions with prominent experts in the commercial, political and cultural
                            fields, as well as company visits. It empowers the students to develop management
                            expertise and cross-functional perspectives to drive performance across domains,
                            industries, and borders.
                        </h6>
                        <a routerLink="/courses/bba" class="btn-read-more">Read More...</a>
                    </div>
                </div>
            </div>
            <!-- BCA -->
            <div class="col d-flex" data-scroll>
                <div class="card mx-auto w-100">
                    <img src="/assets/img/course/BCA.png" alt="BCA" class="card-img img-fluid" />
                    <span class="first">BCA</span>
                    <div class="card-body">
                        <h6 class="line-clamp-5">
                            BCA course is 4 years program. The program covers rudimentary to advanced concepts in
                            Computer Science and its applications in various domains. An exceptionally broad range
                            of topics covering current trends and technologies in the field of information technology
                            and computer science are included in the syllabus. The hands on sessions in Computer
                            labs using various Programming languages and tools are also given to have a deep
                            conceptual understanding of the topics to widen the horizon of students' self-experience.
                        </h6>
                        <a routerLink="/courses/bca" class="btn-read-more">Read More...</a>
                    </div>
                </div>
            </div>
            <!-- BA LLB -->
            <div class="col d-flex" data-scroll>
                <div class="card mx-auto w-100">
                    <img src="/assets/img/course/BA LL.B.png" alt="BA. LL.B. (Hons.)" class="card-img img-fluid" />
                    <span class="second">BA LL.B (HONS.)</span>
                    <div class="card-body">
                        <h6 class="line-clamp-5">
                            BA LL.B (HONS.) course is a 5 years program, which any aspiring student can join to
                            explore the carrier in the profession in the corporate sector, legal firms, with the
                            individual lawyers and judicial services in various states including Delhi. The Institute
                            creates the best cream among the students working in an environment fitted with latest
                            case law available on Manupatra online, various law journals &amp; books and the Moot
                            Court to provide the training to the students for mock courts trials.
                        </h6>
                        <a routerLink="/courses/ba" class="btn-read-more">Read More...</a>
                    </div>
                </div>
            </div>
            <!-- LLM -->
            <div class="col d-flex" data-scroll>
                <div class="card mx-auto w-100">
                    <img src="/assets/img/course/LLM.png" alt="LL.M." class="card-img img-fluid" />
                    <span class="third">LL.M (CL &amp; IPR)</span>
                    <!-- <span class="third">LL.M (Corp. Law) & LL.M (IPR)</span> -->
                    <div class="card-body">
                        <h6 class="line-clamp-5">
                            LL.M course is a 1 year Postgraduate program designed to build advanced legal expertise,
                            which any aspiring student can specialize in diverse careers like IPR, Corporate Law,
                            International Law (UN, NGOs), Judicial Services, Academia/Research or Government roles
                            working as a Legal Advisor, Consultant, Judge, Professor or specialized lawyer in areas
                            like Cyber Law with options in Law Firms, Corporations and Public Sector Undertakings
                            (PSUs).
                        </h6>
                        <a routerLink="/courses/llm" class="btn-read-more">Read More...</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>